import styled, { keyframes } from 'styled-components'

const nudgeLeft = keyframes`
  0%   { transform: translateX(0px);   opacity: 0.75; }
  30%  { transform: translateX(-12px); opacity: 1;    }
  60%  { transform: translateX(0px);   opacity: 0.75; }
  100% { transform: translateX(0px);   opacity: 0.75; }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: 8px;
  background: linear-gradient(145deg, #f8f9ff 0%, #f2f4fc 100%);
  border-radius: 8px;
  border: 1px solid rgba(99, 126, 234, 0.18);
  padding: 8px;
`

export const IllustrationWrapper = styled.div<{ $isPortrait?: boolean }>`
  svg {
    ${({ $isPortrait }) => $isPortrait && 'width: 140px;'}
  }
`

export const ArrowWrapper = styled.div<{ $isPortrait?: boolean }>`
  margin-top: 12px;
  animation: ${nudgeLeft} 2.2s cubic-bezier(0.45, 0, 0.55, 1) infinite;

  ${({ $isPortrait }) =>
    $isPortrait &&
    `
    svg {
      width: 100px;
    }
  `}
`
